import {getLocale} from '@epic-core/common';
import {datasource} from 'alt-utils/lib/decorators';
import {seamlessImmutable} from 'epic-alt-utils';
import alt from 'epic-fortnite-react/alt';
import Immutable from 'seamless-immutable';
import root from 'window-or-global';

import VideoRecapActions from '../actions/VideoRecapActions';
import IdomooSource from '../sources/IdomooSource';
@datasource(IdomooSource)
@seamlessImmutable
class VideoRecapStore {
  constructor() {
    this.on('error', (error) => {
      console.error(error);
    });
    this.state = Immutable({
      cms: null,
      customVideoRecap: null,
      loading: true,
      creating: false,
      error: true,
    });
    this.bindActions(VideoRecapActions);
  }

  onGetContent() {
    this.getInstance().getContent(getLocale());
    this.setState(this.state.set('loading', true));
  }

  onGetContentSuccess(response) {
    const responseData = (response && response.data) || {};
    this.setState(
      this.state.merge({
        loading: false,
        error: false,
        customVideoRecap: responseData.data,
      })
    );
  }

  onGetContentFailure(error) {
    this.setState(
      this.state.merge({
        loading: false,
        error: true,
      })
    );
  }

  onGenerateVideo(payload) {
    this.getInstance().generateVideo(payload, getLocale());
    this.setState(this.state.set('creating', true));
  }

  onGenerateVideoSuccess({data}) {
    // try to pull video link from response and redirect user to the link
    // wait for 5 sec before redirecting to allow Idomoo prepare the video
    try {
      const link = data.output.video[0].links.landingPageUrl; // eslint-disable-line
      setTimeout(() => {
        root.location.href = link;
      }, 5000);
    } catch (ex) {
      console.error('onGenerateVideoSuccess Error ', ex);
      this.setState(
        this.state.merge({
          creating: false,
          error: true,
        })
      );
    }
  }

  onGenerateVideoFailure(error) {
    let errorMsg = null;
    try {
      const {
        response: {
          data: {
            video: {internal_code},
          },
        },
      } = error;
      switch (internal_code) {
        case 1630:
          errorMsg = 'epic.fortnite.idomoo.video.error.scaling';
          break;
        case 3120:
          errorMsg = 'epic.fortnite.idomoo.video.error.noMatch';
          break;
        default:
          errorMsg = 'epic.fortnite.idomoo.video.error';
      }
    } catch (ex) {
      //no-op
      errorMsg = 'epic.fortnite.idomoo.video.error';
    }
    this.setState(
      this.state.merge({
        creating: false,
        error: true,
        errorMsg,
      })
    );
  }

  resetError() {
    this.setState(
      this.state.merge({
        error: false,
        errorMsg: null,
      })
    );
  }
}

export default alt.createStore(VideoRecapStore, 'VideoRecapStore');
